import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  Form,
  Input,
  Button,
  // MessagePlugin,
  // Popconfirm,
  // Space,
  Table,
  DatePicker,
  Tag,
} from 'tdesign-react';
import useTable from '@/hooks/useTable';
import { deleteOpenapiLogs, getOpenapiLogsList } from '@/services/logsService';
import { renderDateTime, renderTags } from '@/utils/common';
import PermWrapper from '@/components/PermWrapper';
import FormModal from '../LogsTable/FormModal';

const { FormItem } = Form;

export const renderResult = ({ row }) =>
  Number(row.returnCode) === 200 ? (
    <Tag variant='light-outline' size='small' theme='success'>
      200
    </Tag>
  ) : (
    <Tag variant='light-outline' size='small' theme='danger'>
      {row.returnCode}
    </Tag>
  );

export default function Logs() {
  const [visible, setVisible] = useState(false);

  const columns = [
    {
      title: '用户id',
      colKey: 'userId',
      cell: renderTags,
      width: 120,
    },
    {
      title: '操作类型',
      colKey: 'operateType',
      ellipsis: true,
    },
    {
      title: '请求url',
      colKey: 'url',
      ellipsis: true,
    },
    {
      title: '请求地址',
      colKey: 'ipPort',
      ellipsis: true,
    },
    {
      title: '结果码',
      colKey: 'returnCode',
      cell: renderResult,
      width: 80,
    },
    {
      title: '请求参数',
      colKey: 'args',
      ellipsis: true,
    },
    {
      title: '请求结果',
      colKey: 'returnContent',
      ellipsis: true,
    },
    {
      title: '操作时间',
      colKey: 'createTime',
      cell: renderDateTime,
      width: 180,
    },
  ];

  const loadData = useMemoizedFn(async (params) => {
    const { data } = await getOpenapiLogsList(params); // api分页无效，暂认为假分页
    setData(data.items, data.count);
  });

  const { setData, doSearch, config, header, doRefresh } = useTable({
    columns,
    search: (
      <>
        <FormItem name='startTime'>
          <DatePicker enableTimePicker placeholder='开始时间' allowInput clearable />
        </FormItem>
        <FormItem name='endTime'>
          <DatePicker enableTimePicker placeholder='结束时间' allowInput clearable />
        </FormItem>
      </>
    ),
    searchExtra: (
      <>
        <FormItem label='操作类型' name='operateType'>
          <Input clearable placeholder='输入操作类型' />
        </FormItem>
        <FormItem label='URL' name='url'>
          <Input clearable placeholder='输入URL' />
        </FormItem>
        <FormItem label='IP端口' name='ipPort'>
          <Input clearable placeholder='输入IP端口' />
        </FormItem>
        <FormItem label='返回code' name='returnCode'>
          <Input clearable placeholder='输入返回code' />
        </FormItem>
      </>
    ),
    onSearch: loadData,
    remote: true,
    operators: (
      <PermWrapper resource='pulsar:sys:logs:OpenApiDelete'>
        <Button theme='danger' onClick={() => setVisible(true)}>
          清理
        </Button>
      </PermWrapper>
    ),
  });

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  const handleClose = (refresh) => {
    setVisible(false);
    if (refresh) {
      doRefresh();
    }
  };
  // const doDelete = async ({ id }) => {
  //   try {
  //     await deleteLogs({ idList: [id], deleteAll: 0 });
  //     MessagePlugin.success('删除成功');
  //     doRefresh();
  //   } catch (error) {
  //     throw error;
  //   }
  // };

  return (
    <Root>
      {header}
      <Table {...config} />
      <FormModal request={deleteOpenapiLogs} visible={visible} handleClose={handleClose} />
    </Root>
  );
}

const Root = styled.div`
  padding-top: 20px;
  .t-radio-button.t-is-checked {
    background-color: var(--td-brand-color-7);
    border-radius: 6px;
    .t-radio-button__label {
      color: #fff;
      font-weight: bold;
    }
  }
  .t-radio-group__bg-block {
    background-color: rgba(0, 0, 0, 0.1) !important;
    border-radius: 6px !important;
  }
`;
